import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const ModalBlock = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16) var(--space-20);
  ${mobile_xl(css`
    padding-inline: var(--space-16);
  `)}
`;

const Formation = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;

const FormBlock = styled.div`
  display: flex;
  gap: var(--space-16);
  ${mobile_xl(css`
    flex-direction: column;
  `)}
`;

const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  span {
    color: var(--accent-error);
  }
`;

const FormButton = styled.div`
  display: flex;
  gap: var(--space-10);
  align-items: flex-end;
  justify-content: flex-end;
  ${mobile_xl(css`
    justify-content: end;
    gap: var(--space-12);
  `)}
`;

const FormView = styled.div`
  position: relative;
  z-index: var(--z-index-base);
`;

const InputDiv = styled.div`
  position: relative;
`;

const SelectedText = styled.div`
  position: absolute;
  top: 8px;
  left: 12px;
  pointer-events: none;
  color: var(--text-primary);
  ${Typography.body_lg}
`;
export { ModalBlock, FormBlock, Form, Label, FormButton, Formation, FormView, InputDiv, SelectedText };
